import React, {useEffect, useRef, useState} from 'react';
import styles from './ScratchEditor.module.scss';

// 真实 Scratch 编辑器（自托管独立版），以 iframe 隔离加载，避免与主应用构建冲突。
// 编辑器资源由 scripts/copy-scratch-gui.mjs 拷贝到 public/scratch/。
export default function ScratchEditor ({
    locale = 'zh-cn',
    lessonId = 'loops',
    lesson,
    activeStep,
    saveRequestId,
    evaluateRequestId,
    onProjectData,
    onProjectSummary,
    onProjectError,
    className = ''
}) {
    const frameRef = useRef(null);
    const [ready, setReady] = useState(false);

    const src = `/scratch/editor.html?locale=${encodeURIComponent(locale)}&lesson=${encodeURIComponent(lessonId)}`;

    useEffect(() => {
        const handleMessage = event => {
            if (event.data?.type === 'cq-editor-ready') setReady(true);
            if (event.data?.type === 'cq-project-data') onProjectData?.(event.data.blob, event.data.requestId);
            if (event.data?.type === 'cq-project-summary') onProjectSummary?.(event.data.projectSummary, event.data.requestId);
            if (event.data?.type === 'cq-project-error') onProjectError?.(event.data.error, event.data.requestId);
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    useEffect(() => {
        if (!saveRequestId || !frameRef.current?.contentWindow) return;
        frameRef.current.contentWindow.postMessage({type: 'cq-save-project', requestId: saveRequestId}, '*');
    }, [saveRequestId]);

    useEffect(() => {
        if (!evaluateRequestId || !frameRef.current?.contentWindow) return;
        frameRef.current.contentWindow.postMessage({type: 'cq-summarize-project', requestId: evaluateRequestId}, '*');
    }, [evaluateRequestId]);

    useEffect(() => {
        if (!activeStep || !frameRef.current?.contentWindow) return;
        frameRef.current.contentWindow.postMessage({
            type: 'cq-step-change',
            step: activeStep,
            lesson
        }, '*');
    }, [activeStep, lesson, ready]);

    return (
        <div className={[styles.wrap, className].filter(Boolean).join(' ')}>
            <iframe
                ref={frameRef}
                className={[styles.frame, ready ? styles.frameReady : ''].join(' ')}
                src={src}
                title="Scratch 编辑器"
                allow="autoplay; microphone; camera; midi"
                onLoad={() => {
                    if (activeStep) {
                        frameRef.current?.contentWindow?.postMessage({type: 'cq-step-change', step: activeStep, lesson}, '*');
                    }
                }}
            />
        </div>
    );
}
